import React, { useState, useEffect, useContext } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  FormGroup,
  Grid,
  Paper,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { withRouter } from "react-router-dom";

const ScenarioGroupCart = ({
  cartItems,
  onRemoveFromCart,
  onGroupCreationSuccess,
  history,
  open_loop_type,
  fctwValue
}) => {
  const [groupName, setGroupName] = useState("");
  const [groupNumber, setGroupNumber] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [error, setError] = useState("");
  const [modelOptions, setModelOptions] = useState([]);
  const [modelName, setModelName] = useState("");
  const [modelError, setModelError] = useState("");
  const [countOfDuplicate, setCountOfDuplicates] = useState(null);
   const [loading, setLoading] = useState(false);

  const handleCreateGroup = () => {
    setLoading(true);
    if(modelName === ""){
      setModelError("Please select model name");
      return;
    }
    const scenarioGroupUUID = uuidv4();
    const listOfScenarios = cartItems.map((item) => item.scenario_name.split(".csv")[0]);
    const uuidList = cartItems.map((item) => item.scenario_uuid);
    const payload = {
      group_name: groupName,
      group_number: groupNumber,
      list_of_scns: listOfScenarios,
      list_of_uuid: uuidList,
      total_scenarios: cartItems.length,
      scenario_group_uuid: scenarioGroupUUID,
      model_name: modelName,
      open_loop_type:open_loop_type,
    };
    if (open_loop_type === 'PR') payload['fctw'] = false;
    else fctwValue ? payload['fctw'] = true : payload['fctw'] = false;
    axios
      .post("/cm__open_loop_base_bulk_grouping_of_scenarios_collection", payload)
      .then((response) => {
        if (response.status === 200) {
          console.log("Group created successfully", response);
          setOpenDialog(true);
        }
      })
      .catch((error) => {
        console.error("There was an error creating the group!", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    history.push(`/open_loop_scenario_group?open-loop-type=${open_loop_type}`);
  };

  const handleGroupNumberChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value > cartItems.length) {
      setGroupNumber(cartItems.length);
      setError(`Group number cannot exceed ${cartItems.length}`);
    } else if (value < countOfDuplicate) {
      setGroupNumber(countOfDuplicate);
      setError(`Group number cannot be less than ${countOfDuplicate}`);
    } else {
      setGroupNumber(e.target.value);
      setError("");
    }
  }

  const countOfDuplicates = () => {
    const result = cartItems.reduce((acc, cur) => {
      acc[cur.scenario_name] = (acc[cur.scenario_name] || 0) + 1;
      return acc;
    }, {});
    setCountOfDuplicates(Math.max(...Object.values(result)));
  }

  const fetchSelectOptions = async () => {
    const response = await axios.post(
      "/cm/close_loop/fetch-carmaker_model_record_V2"
    );
    setModelOptions(response.data);
    const modelName = response.data.filter(
      (model) => model.value === 'Generic'
    )[0].value;
    // console.log(response.data.filter((model) => model._id === selectValue))
    console.log(modelName);
    setModelName(modelName);
  };

  useEffect(() => {
    fetchSelectOptions();
    countOfDuplicates();
  }, []);

  return (
    <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              {cartItems.length === 0 ? (
                <Typography variant="body2">
                  No items selected for grouping
                </Typography>
              ) : (
                <div style={{ height: "250px", overflowY: "auto" }}>
                  Selected <b>{cartItems.length}</b> in the Group
                  {cartItems.slice(0, 10).map((item, index) => (
                    <div
                      key={item.scenario_uuid}
                      style={{ display: "flex", flexDirection: 'column' }}
                    >
                      <Typography variant="body2" style={{ flexGrow: 1 }}>
                        {item.scenario_name.split(".csv")[0]}
                        {/* {item.scenario_name} */}
                      </Typography>
                      {/* <IconButton
                      onClick={() => onRemoveFromCart(item.scenario_uuid)}
                    >
                      <DeleteIcon />
                    </IconButton> */}
                    {index === 9 && cartItems.length > 10 && <div><Typography>{`and ${cartItems.length - 10} more`}</Typography></div>}
                    </div>
                  ))}
                </div>
              )}
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          {cartItems.length > 0 && (
            <Card>
              <CardContent>
                {/* <FormControl
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "10px" }}
                >
                  <Select
                    error={!!modelError}
                    value={modelName}
                    onChange={(e) => {setModelName(e.target.value); setModelError("")}}
                    // readOnly
                  >
                    {modelOptions.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                  { modelError && <FormHelperText error={!!modelError}>{modelError}</FormHelperText>}
                </FormControl> */}
                <FormGroup>
                  <TextField
                    required
                    id="scenario-group-name"
                    label="Scenario Group Name"
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                  <TextField
                    type="number"
                    required
                    id="expected-group-number"
                    label="Expected Group Number"
                    value={groupNumber}
                    onChange={handleGroupNumberChange}
                    fullWidth
                    margin="normal"
                    error={!!error}
                    helperText={error}
                  />
                  {!error && <span style={{fontSize: '12px'}}>Note: Minimum group number should be {countOfDuplicate} and Maximum group number should be less than {cartItems.length}</span>}
                </FormGroup>
                <div style={{ position: "relative" }}>
                   <Button
                      variant="contained"
                      fullWidth
                      style={{
                        marginTop: "10px",
                        backgroundColor: (loading || groupNumber === '' || groupName === '') ? "#b3b3b3" : "#622ad8",
                        color: "white",
                        cursor: 'pointer'
                      }}
                      onClick={handleCreateGroup}
                      disabled={loading || groupNumber === '' || groupName === ''}
                    >
                      Create Group
                    </Button>
                    {loading && (
                      <CircularProgress
                        size={24}
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          marginTop: -12,
                          marginLeft: -12,
                        }}
                      />
                    )}
                </div>
              </CardContent>
            </Card>
          )}
        </Grid>
      </Grid>
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Group Created"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Scenario Group has been created successfully.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default withRouter(ScenarioGroupCart);
